export const STATUS = {
  NONE: "NONE",
  UPCOMING: "UPCOMING",
  NO_STUDENTS: "NO_STUDENTS",
  GRADED: "GRADED",
  TO_BE_GRADED: "TO_BE_GRADED",
};
